 const Content = (props) => <div class="content" style={props.style}>{props.children}</div>;
 export default Content;